









































import { Component, Prop, Vue } from "vue-property-decorator";
import { PTOSignature } from "@/dto/payroll/policies/PTOPolicyDTO";
import { processError } from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import RouteNames from "@/router/RouteNames";
import EmbeddedFile from "@/components/common/EmbeddedFile.vue";
import PTOPolicyCard from "@/components/payroll/policies/pto/PTOPolicyCard.vue";
import PolicyService from "@/services/payroll/PolicyService";

@Component({
	components: { EmbeddedFile, PTOPolicyCard }
})
export default class PTOViewEmployee extends Vue {
	@Prop({ required: true })
	private employmentId!: number;

	private signature: PTOSignature | null = null;
	private loading = true;

	public created() {
		this.load();
	}

	private load() {
		Application.startLoading();
		this.loading = true;
		PolicyService.getPTOPolicyByEmploymentId(this.employmentId)
			.then(res => {
				this.signature = res.data;
				Application.stopLoading();
				this.loading = false;
			})
			.catch(err => {
				this.signature = null;
				this.loading = false;
				Application.stopLoading();
				processError(err, this);
			});
	}

	private toSignPage(publicId: string) {
		this.$router.push({ name: RouteNames.SIGN_PUBLIC, params: { publicId } });
	}
}
